// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/ReceivablesPreviewHeader/index.jsx
import { Divider, Flex, Tag, Typography, theme } from 'antd';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import app from 'configs/ConfigIndex';

const { Text, Title } = Typography;

const dividerStyle = { margin: '24px 0 16px' };
const titleStyle = { marginBottom: 4 };
const tagWrapStyle = { marginBottom: 8 };
const fieldsWrapStyle = { marginTop: 16 };
const labelStyle = { fontSize: 13 };
const valueStyle = { fontSize: 13 };

const ReceivablesPreviewHeader = ({ selectedDocument: r }) => {
  const { token } = theme.useToken();
  const baseColor = app?.baseColor || token.colorPrimary;
  const bgBarStyle = {
    height: 56,
    marginLeft: -24,
    marginRight: -24,
    marginTop: -24,
    marginBottom: 20,
    backgroundColor: baseColor,
  };

  if (!r) return null;

  const customerName = r?.__customer?.name || r?.__customer?.fullName;
  const formattedValue =
    r?.value != null
      ? `R$ ${financialService.formatNumber(r.value, { decimals: 2, locale: 'pt-BR' })}`
      : null;
  const formattedDueDate = r?.dueDate ? dayjs(r.dueDate).format('L') : null;

  return (
    <div>
      <div style={bgBarStyle} />
      <div style={{ textAlign: 'center' }}>
        {r?.status && (
          <div style={tagWrapStyle}>
            <Tag color="blue">{translateX(r.status)}</Tag>
          </div>
        )}
        <Title level={4} style={titleStyle}>
          {customerName || '—'}
        </Title>
        <div style={fieldsWrapStyle}>
          <Flex vertical gap={4} style={{ width: '100%' }}>
            {formattedValue && (
              <InfoRow label={translateX('value')} value={formattedValue} token={token} strong />
            )}
            {formattedDueDate && (
              <InfoRow label={translateX('due_date')} value={formattedDueDate} token={token} />
            )}
            {r?.order && (
              <InfoRow label={translateX('order')} value={String(r.order)} token={token} />
            )}
            {r?.billingType && (
              <InfoRow
                label={translateX('billing_type')}
                value={translateX(r.billingType)}
                token={token}
              />
            )}
          </Flex>
        </div>
        <Divider style={dividerStyle} />
      </div>
    </div>
  );
};

export default ReceivablesPreviewHeader;

function InfoRow({ label, value, token, strong = false }) {
  if (!value) return null;
  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    borderBottom: `1px solid ${token?.colorBorderSecondary}`,
  };
  return (
    <div style={rowStyle}>
      <Text type="secondary" style={labelStyle}>
        {label}:
      </Text>
      <Text strong={strong} style={valueStyle}>
        {value}
      </Text>
    </div>
  );
}
